import { AuthenticationModeSelect } from './AuthenticationModeSelect';
import { RoleSelect } from './RoleSelect';
import { Container } from './styled';
export function RoleAndAuth() {
    return (<Container>
      <RoleSelect />
      <AuthenticationModeSelect />
    </Container>);
}
